module.exports = __webpack_public_path__ + "static/media/Montana2922.ef05c102.jpg";